const ZOOVU_GA_MAX_PARAMS = 25;
const ZOOVU_GA_MAX_VALUE_LENGTH = 100;
const ZOOVU_GA_MAX_KEY_LENGTH = 40;
const ZOOVU_GA_PRODUCT_FLATTEN_EVENTS = ['go-to-product-details', 'recommendations-fetch'];

class ZoovuGaTracking extends CustomElement {
  props = {
    sendTo: null
  };

  mounted() {
    try {
      if (typeof window.ZoovuSDK === 'undefined' || typeof window.ZoovuSDK.assistantInit !== 'function') {
        return;
      }

      window.ZoovuSDK.assistantInit(() => {
        this.setAttribute('data-zoovu-ga-ready', 'true');

        if (window.__zoovuGaListenerAttached) return;
        window.__zoovuGaListenerAttached = true;

        window.ZoovuSDK.events.listenToAll((event) => this.trackEvent(event));
      });
    } catch (error) {
      console.error('[zoovu-ga-tracking] failed to initialize', error);
    }
  }

  trackEvent(event) {
    try {
      if (typeof window.gtag !== 'function') return;

      const name = event?.name;

      if (typeof name === 'string' && name.length > ZOOVU_GA_MAX_KEY_LENGTH) {
        console.warn(`[zoovu-ga-tracking] event name "${name}" exceeds GA4's ${ZOOVU_GA_MAX_KEY_LENGTH}-character limit`);
      }

      const flattened = this.flattenProductFields(name, event?.data);
      const sanitizedData = this.sanitize(flattened);

      window.gtag('event', name, {
        ...sanitizedData,
        send_to: this.props.sendTo
      });
    } catch (error) {
      console.error('[zoovu-ga-tracking] failed to track event', event, error);
    }
  }

  flattenProductFields(eventName, data) {
    if (!data || typeof data !== 'object' || !ZOOVU_GA_PRODUCT_FLATTEN_EVENTS.includes(eventName)) {
      return data;
    }

    const flattened = { ...data };

    if (Array.isArray(flattened.products)) {
      const [firstProduct] = flattened.products;

      if (firstProduct && typeof firstProduct === 'object') {
        Object.entries(firstProduct).forEach(([key, value]) => {
          flattened[`product_${key}`] = value;
        });
      }

      delete flattened.products;
    }

    if (flattened.product && typeof flattened.product === 'object') {
      Object.entries(flattened.product).forEach(([key, value]) => {
        flattened[`product_${key}`] = value;
      });
      delete flattened.product;
    }

    return flattened;
  }

  sanitize(data) {
    const sanitized = {};

    if (!data || typeof data !== 'object') return sanitized;

    Object.entries(data)
      .slice(0, ZOOVU_GA_MAX_PARAMS)
      .forEach(([key, value]) => {
        if (key.length > ZOOVU_GA_MAX_KEY_LENGTH) {
          console.warn(`[zoovu-ga-tracking] param name "${key}" exceeds GA4's ${ZOOVU_GA_MAX_KEY_LENGTH}-character limit`);
        }

        let sanitizedValue;

        if (Array.isArray(value)) {
          const hasNestedObject = value.some((item) => item !== null && typeof item === 'object');
          if (hasNestedObject) return;
          sanitizedValue = value.join(',');
        } else if (value !== null && typeof value === 'object') {
          return;
        } else {
          sanitizedValue = value;
        }

        if (typeof sanitizedValue === 'string' && sanitizedValue.length > ZOOVU_GA_MAX_VALUE_LENGTH) {
          sanitizedValue = sanitizedValue.slice(0, ZOOVU_GA_MAX_VALUE_LENGTH);
        }

        sanitized[key] = sanitizedValue;
      });

    return sanitized;
  }
}

customElements.define('zoovu-ga-tracking', ZoovuGaTracking);
